
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/transfer/platform-payments",
      function () {
        return require("private-next-pages/docs/transfer/platform-payments.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/transfer/platform-payments"])
      });
    }
  